var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBmLogoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.5 511.5",
    style: {
      enableBackground: "new 0 0 511.5 511.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ff6f00;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.9,511.5H108.6C48.9,511.5,0,462.6,0,402.9V108.6C0,48.9,48.9,0,108.6,0h294.3 c59.7,0,108.6,48.9,108.6,108.6v294.3C511.5,462.6,462.6,511.5,402.9,511.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.9,85.1c-15.5-15.5-40.7-15.5-56.2,0l-23.1,23.1c-15.5,15.5-15.5,40.7,0,56.2l85.3,85.3l80.9-0.1 l-0.3-77.9L162.9,85.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M427.9,164.5c15.5-15.5,15.5-40.7,0-56.2l-23.1-23.1c-15.5-15.5-40.7-15.5-56.2,0L262,171.7l-0.3,77.9 l80.9,0.1L427.9,164.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M342.7,261.7l-80.9,0.1l0.3,77.9l86.6,86.6c15.5,15.5,40.7,15.5,56.2,0l23.1-23.1c15.5-15.5,15.5-40.7,0-56.2 L342.7,261.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.5,347c-15.5,15.5-15.5,40.7,0,56.2l23.1,23.1c15.5,15.5,40.7,15.5,56.2,0l86.6-86.6l0.3-77.9l-80.9-0.1 L83.5,347z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmLogoBackground);
export default __webpack_public_path__ + "static/media/bm-logo-background.85cc61b7808791cbc500e2a1576c9ab7.svg";
export { ForwardRef as ReactComponent };